(function () {
  "use strict";

  ManageUsersCtrl.$inject = ['$scope', '$rootScope', '$location', 'resolveData', 'userGridUtils', 'mtypes', 'authView', 'usersResource', 'accountFeatures', 'Validation', '$window', 'trackingService', 'manageUsersSearch', 'sorting', 'manageUsersGrouping', '$timeout', 'compositeSearchData', 'sortHelper', 'trainerPrivilege', 'actionLogResource'];
  angular
    .module('trainerWebApp.controllers')
    .controller('ManageUsersCtrl', ManageUsersCtrl);

  function ManageUsersCtrl($scope, $rootScope, $location, resolveData, userGridUtils, mtypes, authView, usersResource,
                           accountFeatures, Validation, $window, trackingService, manageUsersSearch, sorting, manageUsersGrouping,
                           $timeout, compositeSearchData, sortHelper, trainerPrivilege, actionLogResource) {

    $window.document.title = "Manage Users | Mindflash Training Management System";

    $rootScope.page = {name: 'manageUsers', title: "Manage Users"};

    $scope.courseAndSeriesStateCache = {
      courses: {},
      series: {}
    };
    var usersLookup = {};
    var allUsers = resolveData.users;
    _.each(allUsers, function (user) {
      user.name = user.lastName + ', ' + user.firstName;
      user.roleName = getUserRole(user.isOwner, user.permissions, user.status);
      usersLookup[user.id] = user;
    });

    var editCustomFieldForMultipleUsersUri = 'pages/users/multiEditCustomFieldsSidebar.html';
    var editUserGroupsUri = 'pages/users/editGroupsSidebar.html';
    var editUserCoursesAndSeriesUri = 'pages/users/editCoursesAndSeriesSidebar.html';

    var selectedRows = null;
    var updatingDueToSearch = false;
    var changingUserStateToggle = false;
    var userRole = trainerPrivilege.roles();

    $scope.overridePlaceholder = 'Search by name, group, or course';
    $scope.openSidebarPlaceholder = 'Search by name, group, or course';

    $scope.customUserFields = resolveData.customFields;
    $scope.customFieldInEdit = null;

    $scope.canInviteUsers = userRole.canInviteUsers;
    $scope.canArchive = userRole.canArchiveUsers;
    $scope.canEditCustomFields = userRole.canEditCustomFields;

    actionLogResource.writeActionLog([{action: mtypes.actionType.viewedManageUsers}]);

    $scope.editCustomFieldForMultipleUsers = function (field) {
      $scope.customFieldInEdit = field;
      $scope.changeSidebar(editCustomFieldForMultipleUsersUri);
    };

    $scope.editUsersGroups = function (userGroupsGrouped) {
      $scope.userGroupsInEdit = userGroupsGrouped;
      $scope.changeSidebar(editUserGroupsUri);
    };

    $scope.editUsersCoursesAndSeries = function (userCoursesGrouped, userSeriesGrouped) {
      $scope.userCoursesInEdit = userCoursesGrouped;
      $scope.userSeriesInEdit = userSeriesGrouped;
      $scope.changeSidebar(editUserCoursesAndSeriesUri);
    };

    $scope.exitCustomFieldForMultipleEditor = function () {
      $scope.openMultiUserDetailsSidebar();
    };

    $scope.openDetailsSidebar = function () {
      if ($scope.selectedUser)
        $scope.openSingleUserDetailsSidebar();
      else
        $scope.openMultiUserDetailsSidebar();
    };

    $scope.allUserGroups = resolveData.userGroups;
    var groupLookup = {};
    _.each(resolveData.userGroups, function (g) {
      groupLookup[g.id] = g;
    });
    $scope.userGroupLookup = groupLookup;

    $scope.allCourses = resolveData.courses;
    var courseLookup = {};
    _.each(resolveData.courses, function (c) {
      courseLookup[c.id] = c;
    });
    $scope.courseLookup = courseLookup;

    $scope.allSeries = resolveData.series;
    var seriesLookup = {};
    _.each(resolveData.series, function (s) {
      seriesLookup[s.id] = s;
    });
    $scope.seriesLookup = seriesLookup;

    $scope.addNewGroupToSearch = function (group) {
      $scope.allUserGroups.push(group);
      $scope.userGroupLookup[group.id] = group;
    };

    $scope.$on('newGroupCreated', function (event, group) {
      $scope.addNewGroupToSearch(group);
    });

    function filterSampleCourse(courses) {
      if (!~accountFeatures.features.indexOf(mtypes.featureEntry.trainerHTMLHome)) {
        return _.filter(courses, function (item) {
          return item.id != mfConfig.sampleCourseId;
        });
      }

      return courses;
    }

    function setupSearch() {
      $scope.searchSettings = manageUsersSearch.createSearchSettings({
        courses: filterSampleCourse(resolveData.courses),
        customFields: resolveData.customFields,
        filterHasResults: filterHasResults,
        gaPageName: trackingService.pages.usersManage.name,
        groups: resolveData.userGroups,
        loadCourseStates: loadCourseStates,
        loadSeriesStates: loadSeriesStates,
        series: resolveData.series,
        setFilter: setSearchFilter,
        notifySearchChanged: notifySearchChanged
      });
    }

    if (!allUsers) return;

    $scope.selectedUser = null;
    $scope.sidebarContentSrc = null;
    $scope.showArchived = false;
    $scope.archivedCriteria = 'active';
    $scope.roleVisible = true; // don't tie this flag to maxTeamMembers anymore
    $scope.canModifyRole = ($scope.roleVisible && authView.isAdministrator());
    $scope.selectedUserTabSelected = 'courses';
    $scope.goodDataTraineesDashboardLinkVisible = authView.showGoodData();
    $scope.goodDataUrlForTraineesDashboard = authView.getGoodDataUrlForTraineesDashboard();

    $scope.manageUsersEditors = {
      coursesAndSeriesEditor: false,
      editUserInfoSidebar: false,
      multiCustomFieldsEditor: false,
      userGroupsEditor: false
    };

    var gridCommands = $scope.gridCommands = {};
    allUsers = allUsers.sort(userGridUtils.sort.byPersonName);
    $scope.gridData = allUsers;

    $scope.selectedUsers = null;

    $scope.collapsedSidebarSrc = null;

    $scope.closeSidebar = function () {
      if (checkIfEditorsAreDirty()) {
        $scope.$broadcast('showUnsavedChanges', {
          cancelEventName: 'cancelSelection',
          leaveEventName: 'proceedWithCloseSidebar',
          text: 'By changing the selected users, your changes will be lost. Are you sure you want to continue?'
        });
        return;
      }
      proceedWithSidebarCollapse();
    };

    function proceedWithSidebarCollapse() {
      $scope.sidebarContentSrc = null;
    }


    $scope.openSidebar = function () {
      //selectUsers(null);
      $scope.sidebarContentSrc = $scope.collapsedSidebarSrc;
    };

    $scope.$watch('sidebarContentSrc', function (newValue, oldValue) {
      if (oldValue && !newValue && ($scope.selectedUser || $scope.selectedUsers)) {
        $scope.collapsedSidebarSrc = oldValue;
      }
      else {
        $scope.collapsedSidebarSrc = null;
      }
    });

    function getUserRole(isOwner, permissions, status) {
      if (status == mtypes.userStatus.archived)
        return "Archived";

      if (isOwner) return 'Administrator (Owner)';

      switch (permissions) {
        case mtypes.userRole.trainee:
          return 'Trainee';
        case mtypes.userRole.reporter:
          return 'Reporter';
        case mtypes.userRole.teamLead:
          return 'Team Lead';
        case mtypes.userRole.manager:
          return 'Manager';
        case mtypes.userRole.trainer:
          return 'Trainer';
        case mtypes.userRole.administrator:
          return 'Administrator';
        default:
          return '';
      }
    }

    $scope.filter = function (itemToFilter, args) {
      if (!args) return true;

      var user = sortHelper.getDataFromGridItem(itemToFilter);

      if (args.showArchived != (user.status == mtypes.userStatus.archived))
        return false;

      return !args.searchFilter || args.searchFilter(user);
    };


    function filterHasResults(searchFilter) {
      var firstUser = _.find($scope.getVisibleGridItems(), function (u) {
        return $scope.filter(u, $scope.gridFilterData) && searchFilter(u);
      });
      return !!firstUser;
    }

    function loadDataForSearch(options, cb) {
      usersResource.getSetupForManageUsersSearch(options, function (result) {
        cb(result);
      });
    }

    function loadCourseStates(id, cb) {
      loadDataForSearch({courseId: id}, function (result) {
        $scope.courseAndSeriesStateCache.courses[id] = result.courseStates;
        cb(result.courseStates);
      });
    }

    function loadSeriesStates(id, cb) {
      loadDataForSearch({seriesId: id}, function (result) {
        $scope.courseAndSeriesStateCache.series[id] = result.seriesStates;
        cb(result.seriesStates);
      });
    }

    var searchData = compositeSearchData.getSearchData();

    var searchFilter = null;

    if (searchData) {
      if (searchData.name == 'group') {
        searchFilter = userGridUtils.filter.createFilter(
          userGridUtils.filter.byGroupMembership,
          [searchData.id]);
      } else if (searchData.name == 'user') {

        var user = _.find(allUsers, function (t) {
          return t.id == searchData.id;
        });

        if (user.email) {
          searchFilter = userGridUtils.filter.createFilter(
            userGridUtils.filter.byEmail,
            [user.email]);

          searchData.name = "email";
          searchData.id = user;
        } else if (user.username) {
          searchFilter = userGridUtils.filter.createFilter(
            userGridUtils.filter.byUsername,
            [user.username]);

          searchData.name = "username";
          searchData.id = user;
        }
      }

      compositeSearchData.clearSearchData();
    }

    function setSearchFilter(filter) {
      updatingDueToSearch = true;
      searchFilter = filter;
      $scope.applyGridFilter();
    }

    function notifySearchChanged(items) {
      var courseAndSeriesCount = 0;
      var statusColumnState = {isCourseStates: true, id: ''};
      var courseIds = {};
      var seriesIds = {};
      _.each(items, function (i) {
        if (i.field && i.dataForFilter) {
          statusColumnState.id = i.dataForFilter;
          if (i.field.name == "course") {
            statusColumnState.isCourseStates = true;
            courseIds[i.dataForFilter] = true;
            courseAndSeriesCount++;
          }
          else if (i.field.name == "series") {
            statusColumnState.isCourseStates = false;
            seriesIds[i.dataForFilter] = true;
            courseAndSeriesCount++;
          }
        }
      });

      _.each(_.keys($scope.courseAndSeriesStateCache.courses), function (courseId) {
        if (!courseIds[courseId]) {
          delete $scope.courseAndSeriesStateCache.courses[courseId];
        }
      });

      _.each(_.keys($scope.courseAndSeriesStateCache.series), function (seriesId) {
        if (!seriesIds[seriesId]) {
          delete $scope.courseAndSeriesStateCache.series[seriesId];
        }
      });

      if (courseAndSeriesCount == 1) { //only makes sense if there is one course or one series
        statusColumnState.states = statusColumnState.isCourseStates ?
          $scope.courseAndSeriesStateCache.courses[statusColumnState.id] :
          $scope.courseAndSeriesStateCache.series[statusColumnState.id];
        $scope.statusColumnState = statusColumnState;
        $scope.showStatusColumn();
      }
      else {
        $scope.statusColumnState = null;
        $scope.hideStatusColumn();
      }
    }

    function editCustomField() {
      $location.path('/TMS/Manage_Account/');
    }

    function checkIfEditorsAreDirty() {
      return _.some(_.values($scope.manageUsersEditors), function (v) {
        return v;
      })
    }

    function clearEditorsDirtyFlags() {
      _.each(_.keys($scope.manageUsersEditors), function (k) {
        $scope.manageUsersEditors[k] = false;
      });
    }

    var usersToSelect = null;

    function highlightRow(user) {
      if (gridCommands.highlightGridRow)
        gridCommands.highlightGridRow(user && user.id);
    }

    $scope.hasCheckedRows = false;

    function interruptSelectionChange(users) {
      usersToSelect = users;
      $scope.$broadcast('showUnsavedChanges', {
        cancelButtonTitle: 'Stay and Keep',
        cancelEventName: 'cancelSelection',
        leaveButtonTitle: 'Leave and Discard',
        leaveEventName: 'proceedWithSelection',
        text: 'You have made changes in this view&mdash;changing views now will cause your changes to be lost. <br /><br />Do you wish to continue?',
        title: 'Discard changes?'
      });
    }

    function selectSingleUser(user) {
      selectedRows = gridCommands.getSelectedRows();
      if (($scope.selectedUser && $scope.selectedUser.id == user.id)) {
        updatingDueToSearch = changingUserStateToggle = false;
        return;
      }

      if (checkIfEditorsAreDirty()) {
        interruptSelectionChange([user]);
        return;
      }

      $scope.selectedUser = user;
      $scope.selectedUsers = null;

      // If we are currently editing users we can keep editing users even when we go from one to multiple users.
      //if ($scope.sidebarContentSrc != editUserGroupsUri)
      $scope.openSingleUserDetailsSidebar();
      $scope.refreshSelectedUserInfo(function () {
        $scope.updateAfterSideBarShown();
      });

      if (!$scope.hasCheckedRows)
        highlightRow(user);
      updatingDueToSearch = changingUserStateToggle = false;
    }

    function selectMultipleUsers(users, proceedAfterInterrupt) {
      if ($scope.selectedUsers && $scope.selectedUsers.length == users.length) {
        var selectedIds = _.pluck($scope.selectedUsers, 'id');
        if (_.difference(selectedIds, _.pluck(users, 'id')).length == 0) {
          //selection was not changed
          updatingDueToSearch = changingUserStateToggle = false;
          return;
        }
      }

      if (checkIfEditorsAreDirty()) {
        interruptSelectionChange(users);
        return;
      }

      $scope.selectedUsers = users;
      $scope.selectedUser = null;
      selectedRows = gridCommands.getSelectedRows();
      $scope.refreshSelectedUserInfo(function () {
        if (!proceedAfterInterrupt && $scope.sidebarContentSrc == editCustomFieldForMultipleUsersUri) {
          manageUsersGrouping.setupCustomFieldValues($scope.selectedUsers, $scope.customFieldInEdit);
        } else if (!proceedAfterInterrupt && $scope.sidebarContentSrc == editUserGroupsUri) {
          $scope.userGroupsGrouped = manageUsersGrouping.groupUserGroups($scope.selectedUsers, $scope.userGroupLookup);
          $scope.userGroupsInEdit = $scope.userGroupsGrouped;
          $scope.$broadcast('refreshAvailableGroupSelectItems');
        } else if (!proceedAfterInterrupt && $scope.sidebarContentSrc == editUserCoursesAndSeriesUri) {
          $scope.userCoursesGrouped = manageUsersGrouping.groupUserCourses($scope.selectedUsers, $scope.courseLookup);
          $scope.userCoursesInEdit = $scope.userCoursesGrouped;
          $scope.userSeriesGrouped = manageUsersGrouping.groupUserSeries($scope.selectedUsers, $scope.seriesLookup);
          $scope.userSeriesInEdit = $scope.userSeriesGrouped;
          $scope.$broadcast('refreshAvailableCourseAndSeriesSelectItems');
        } else {
          $scope.openMultiUserDetailsSidebar();
        }
        highlightRow(null);
        updatingDueToSearch = changingUserStateToggle = false;
      });
    }

    function removeSelection() {
      if (!$scope.selectedUser && !$scope.selectedUsers) {
        updatingDueToSearch = changingUserStateToggle = false;
        return;
      }

      if (checkIfEditorsAreDirty()) {
        interruptSelectionChange(null);
        return;
      }

      $scope.selectedUser = null;
      $scope.selectedUsers = null;
      selectedRows = null;
      $scope.updateAfterSideBarHidden();
      highlightRow(null);
      $scope.sidebarContentSrc = null;
      $scope.collapsedSidebarSrc = null;
      updatingDueToSearch = changingUserStateToggle = false;
    }


    function selectUsers(users, proceedAfterInterrupt) {
      if (!users || users.length == 0) {
        removeSelection();
      } else if (users.length == 1) {
        selectSingleUser(users[0]);
      } else {
        selectMultipleUsers(users, proceedAfterInterrupt);
      }
    }

    $scope.$on('proceedWithSelection', function () {
      clearEditorsDirtyFlags();
      selectUsers(usersToSelect, true);
      usersToSelect = null;
      updatingDueToSearch = changingUserStateToggle = false;
    });

    $scope.$on('proceedWithCloseSidebar', function () {
      clearEditorsDirtyFlags();
      proceedWithSidebarCollapse();
    });

    $scope.$on('cancelSelection', function () {
      if (updatingDueToSearch) {
        $scope.$broadcast('removeLastFilter', function () {
          /*setTimeout(function () {
           gridCommands.setSelectedRows(selectedRows);
           }, 1);*/
        });
      } else if (changingUserStateToggle) {
        $scope.archivedCriteria = $scope.archivedCriteria == 'archived' ? 'active' : 'archived';
        $scope.showArchived = $scope.archivedCriteria == 'archived';
        $scope.applyGridFilter();
        /*setTimeout(function() {
         gridCommands.setSelectedRows(selectedRows);
         }, 1);*/
      } else {
        gridCommands.setSelectedRows(selectedRows);
      }
    });

    $scope.refreshSelectedUserInfo = function (cb) {
      var loadMultipleUserInfo = function (users) {
        if (users.length === 0) {
          if (cb) return cb();
        }
        var params = {
          userIds: _.pluck(users, 'id'),
          includeCourseAndSeriesInfo: true
        };
        // all users in the account are selected, so send them back
        if (allUsers.length === $scope.selectedUsers.length)
          params.userIds = [];

        $scope.showSpinner();
        usersResource.getMultipleUserInfo(params, function (result) {
          // result is an object keyed by userId
          gridCommands.beginUpdate();

          var updatedUserInfos = [];

          _.each(result, function (value, key) {
            key = parseInt(key);
            if (_.isNaN(key) || !usersLookup[key]) return;

            usersLookup[key].courses = value.courses;
            usersLookup[key].series = value.series;
            usersLookup[key].isOwner = value.isOwner;
            usersLookup[key].permissions = value.permissions;
            usersLookup[key].status = value.status;
            usersLookup[key].roleName = getUserRole(value.isOwner, value.permissions, value.status);
            usersLookup[key].groupMemberships = value.groupMemberships;
            usersLookup[key].customField0 = value.customField0;
            usersLookup[key].customField1 = value.customField1;
            usersLookup[key].customField2 = value.customField2;
            usersLookup[key].customField3 = value.customField3;
            usersLookup[key].customField4 = value.customField4;
            usersLookup[key].customField5 = value.customField5;
            usersLookup[key].customField6 = value.customField6;
            usersLookup[key].customField7 = value.customField7;
            usersLookup[key].customField8 = value.customField8;
            usersLookup[key].customField9 = value.customField9;

            updatedUserInfos.push(usersLookup[key]);

            gridCommands.updateItem(key, usersLookup[key]);
          });
          gridCommands.endUpdate();

          $scope.selectedUsers = updatedUserInfos;

          if ($scope.selectedUser) {
            $scope.selectedUser = usersLookup[$scope.selectedUser.id];
          }

          $scope.hideSpinner();
          if (cb) cb();
        });
      };

      if ($scope.selectedUsers && $scope.selectedUsers.length > 0) {
        loadMultipleUserInfo($scope.selectedUsers);
      } else if ($scope.selectedUser) {
        usersResource.getUserInfo($scope.selectedUser.id, function (result) {
          var updatedUser = result;
          updatedUser.roleName = getUserRole(updatedUser.isOwner, updatedUser.permissions, updatedUser.status);
          $scope.selectedUser = updatedUser;

          var groups = _.map(updatedUser.groupMemberships, function (id) {
            var g = groupLookup[id];
            if (!g)
              return null;

            return {
              groupId: g.id,
              groupName: g.name
            };
          });

          groups.sort(sorting.byName('groupName'));

          $scope.selectedUser.groups = _.filter(groups, function (g) {
            return g;
          });

          if ($scope.selectedUser.courses) {
            if ($scope.selectedUser.courses.required)
              $scope.selectedUser.courses.required.sort(sorting.byName('name'));
            if ($scope.selectedUser.courses.optional)
              $scope.selectedUser.courses.optional.sort(sorting.byName('name'));
            if ($scope.selectedUser.courses.completed)
              $scope.selectedUser.courses.completed.sort(sorting.byName('name'));
          }
          if ($scope.selectedUser.series) {
            if ($scope.selectedUser.series.required)
              $scope.selectedUser.series.required.sort(sorting.byName('name'));
            if ($scope.selectedUser.series.optional)
              $scope.selectedUser.series.optional.sort(sorting.byName('name'));
            if ($scope.selectedUser.series.completed)
              $scope.selectedUser.series.completed.sort(sorting.byName('name'));
          }

          usersLookup[updatedUser.id] = updatedUser;
          gridCommands.updateItem($scope.selectedUser.id, $scope.selectedUser);

          if (cb) cb();
        });
      }
      else {
        if (cb) cb();
      }
    };

    $scope.cleanSelection = function () {
      gridCommands.cleanSelection();

    };

    $scope.applyGridFilter = function () {
      $scope.gridFilterData = {
        searchFilter: searchFilter,
        showArchived: $scope.showArchived
      };
    };
    $scope.applyGridFilter();

    $scope.onRowClick = function (item, targetClasses, options) {
      if (!allUsers || allUsers.length == 0) return;

      if (!$scope.hasCheckedRows) {
        selectUsers([item]);
      } else if (!options.isCheckBoxColumn) {
        $scope.toggleItemSelectionById(item.id);
      }
    };

    $scope.onRowCountChanged = function (args, items) {
      $scope.numberOfTraineesVisible = items.length;
      $scope.numberOfTraineesLabel = items.length + " " + (items.length == 1 ? "user" : "users");

      if (!$scope.hasCheckedRows && $scope.selectedUser) {
        var isSelectedUserInGrid = _.some(items, function (item) {
          return item.id == $scope.selectedUser.id;
        });
        if (!isSelectedUserInGrid) {
          //Need to delay because of highlight state change, if we invalidate grid rows from this method this will cause grid to fail in some cases.
          $timeout(selectUsers, 0);
        }
      }
    };

    $scope.onSelectedRowsChanged = function (args, itemIds) {
      if (!itemIds || !itemIds.length) {
        //Can happened when filter was changes, selection removed and than you highlight the row.
        if (!$scope.hasCheckedRows)
          return;

        $scope.hasCheckedRows = false;
        $scope.numberOfSelectedTraineesLabel = null;
        if ($scope.selectedUser) {
          highlightRow($scope.selectedUser);
          if (itemIds.indexOf($scope.selectedUser) == -1)
            selectUsers(null);
          else
            updatingDueToSearch = changingUserStateToggle = false;
          return;
        }
      } else {
        $scope.numberOfSelectedTraineesLabel = " | " + itemIds.length + " " + (itemIds.length == 1 ? "user" : "users") + " selected | ";
        $scope.hasCheckedRows = true;
        highlightRow(null);
      }

      if (selectedUsersHasChanged(itemIds)) {
        selectUsers(_.map(itemIds, function (i) {
          return usersLookup[i];
        }));
      }
    };

    function selectedUsersHasChanged(newSelectedIds) {
      // Utilizing the fact that there's no way to change the selected users without also changing the number of
      // selected users to avoid comparing the two arrays. If this changes at some point then this won't work,
      // but for now it's more performant.
      if ($scope.selectedUser)
        return true;
      else if ($scope.selectedUsers && !newSelectedIds)
        return true;
      else if (!$scope.selectedUsers && newSelectedIds)
        return true;
      else if ($scope.selectedUsers && newSelectedIds && $scope.selectedUsers.length != newSelectedIds.length)
        return true;

      return false;
    }

    Validation.addValidation(validate);

    var nextLocation;

    function validate() {
      if (!checkIfEditorsAreDirty())
        return true;

      nextLocation = $rootScope.newLocation.next;
      $scope.$broadcast('showUnsavedChanges', {
        leaveEventName: "unsavedChangesPageLeave",
        text: null
      });
      return false;
    }

    $scope.$on('unsavedChangesPageLeave', function () {
      Validation.removeValidation(validate);
      setTimeout(function () {
        $location.path(nextLocation.path).search(nextLocation.search);
        $rootScope.$apply();
      }, 100)
    });

    $scope.$on('$destroy', function () {
      Validation.removeValidation(validate);
    });

    $scope.$on('appOnBeforeUnload', function (e) {
      if (checkIfEditorsAreDirty())
        e.preventDefault();
    });

    $scope.clearChecked = function () {
      selectUsers(null);
      gridCommands.cleanSelection();
    };

    $scope.viewGoodDataReport = function () {
      trackingService.trackEvent(
        trackingService.pages.usersManage.name,
        trackingService.pages.usersManage.actions.viewGoodDataUsersReport);
    };

    $scope.updateUserGroups = function (groups) {
      $scope.allUserGroups = groups;
    };

    $scope.statusColumnSorter = function (item1, item2) {
      var state1 = $scope.statusColumnState.states[item1.id];
      var state2 = $scope.statusColumnState.states[item2.id];
      return userGridUtils.sort.byCourseStatus(state1, state2);
    };

    $scope.filterByCourseId = function (courseId) {
      $scope.$broadcast('clearSearch');

      var field = _.find($scope.searchSettings.fields, function (f) {
        return f.name == 'course';
      });

      var course = _.find(field.getSuggestions(), function (d) {
        return d.id == courseId;
      });

      var searchItem = {
        id: field.label + "|" + courseId,
        label: field.label,
        text: course.name,
        field: field,
        dataForFilter: courseId,
        track: field.track
      };
      $scope.$broadcast('doSearch', [searchItem]);
    };

    $scope.filterBySeriesId = function (seriesId) {
      $scope.$broadcast('clearSearch');

      var field = _.find($scope.searchSettings.fields, function (f) {
        return f.name == 'series';
      });

      var series = _.find(field.getSuggestions(), function (d) {
        return d.id == seriesId;
      });

      var searchItem = {
        id: field.label + "|" + seriesId,
        label: field.label,
        text: series.name,
        field: field,
        dataForFilter: seriesId,
        track: field.track
      };

      $scope.$broadcast('doSearch', [searchItem]);
    };

    $scope.filterByGroupId = function (groupId) {

      $scope.$broadcast('clearSearch');

      var searchItem = getFilterByGroupSearchItem(groupId);

      $scope.$broadcast('doSearch', [searchItem]);
    };

    function filterByGroupId(groupId) {
      var searchItem = getFilterByGroupSearchItem(groupId);

      compositeSearchData.setSearchItem(searchItem);
    }

    function getFilterByGroupSearchItem(groupId) {
      var field = _.find($scope.searchSettings.fields, function (f) {
        return f.name == 'group';
      });

      var group = _.find(field.getSuggestions(), function (d) {
        return d.id == groupId;
      });

      return {
        id: field.label + "|" + groupId,
        label: field.label,
        text: group.name,
        field: field,
        dataForFilter: groupId,
        track: field.track
      };
    }

    function filterByEmail(user) {
      var field = _.find($scope.searchSettings.fields, function (f) {
        return f.name == 'email';
      });

      var searchItem = {
        id: field.label + "|" + user.id,
        label: field.label,
        text: user.email,
        field: field,
        dataForFilter: user.email,
        track: field.track
      };

      compositeSearchData.setSearchItem(searchItem);

    }

    function filterByUsername(user) {
      var field = _.find($scope.searchSettings.fields, function (f) {
        return f.name == 'username';
      });

      var searchItem = {
        id: field.label + "|" + user.id,
        label: field.label,
        text: user.username,
        field: field,
        dataForFilter: user.username,
        track: field.track
      };

      compositeSearchData.setSearchItem(searchItem);
    }

    $scope.showSpinner = function () {
      $rootScope.$broadcast('$showLoadingSpinner', true);
    };

    $scope.hideSpinner = function () {
      $rootScope.$broadcast('$showLoadingSpinner', false);
    };

    $scope.$watch('archivedCriteria', function (item) {
      if (!item) return;
      changingUserStateToggle = true;
      var oldValue = $scope.showArchived;
      $scope.showArchived = item == 'archived';
      if (oldValue != $scope.showArchived)
        $scope.applyGridFilter();
    });

    $rootScope.$watchCollection('mfConfig.features', function () {
      updateHasSeriesFeature();
    });

    $rootScope.$watchCollection('mfConfig.trialFeatures', function () {
      updateHasSeriesFeature();
    });

    function updateHasSeriesFeature() {
      if ($rootScope.mfConfig && $rootScope.mfConfig.features)
        $scope.hasSeriesFeature = $rootScope.mfConfig.features.indexOf(mtypes.featureEntry.series) >= 0;
      if ($rootScope.mfConfig && $rootScope.mfConfig.trialFeatures)
        $scope.hasSeriesFeature = $scope.hasSeriesFeature ||
        $rootScope.mfConfig.trialFeatures.indexOf(mtypes.featureEntry.series) >= 0;
    }

    $scope.getCourseSeriesHeaderButtonsContainerClasses = function (mode) {
      var classes = '';
      if (!$scope.showArchived && userRole.canInviteUsers && mode != 'edit')
        classes = classes + ' courses-series-tab-buttons-with-plus-button';
      if (!$scope.hasSeriesFeature)
        classes = classes + ' courses-series-tab-buttons-no-series';
      return classes;
    };

    $scope.showAddYammerUsers = function () {
      return $scope.yammerEnabled && !mfConfig.useGroupRestrictions;
    };

    $scope.courseActions = function (courseId, $actionEvent) {
      if ($actionEvent.action == 'search') {
        trackingService.trackEvent(trackingService.pages.usersManage.name, trackingService.pages.usersManage.actions.filterByCourseAction);
        $scope.filterByCourseId(courseId);
      } else {
        trackingService.trackEvent(trackingService.pages.usersManage.name, trackingService.pages.usersManage.actions.openCourseAction);
        $location.path('/TMS/Course_Dashboard/' + courseId);
      }
    };

    $scope.seriesActions = function (courseId, $actionEvent) {
      if ($actionEvent.action == 'search') {
        trackingService.trackEvent(trackingService.pages.usersManage.name, trackingService.pages.usersManage.actions.filterBySeriesAction);
        $scope.filterBySeriesId(courseId);
      } else {
        trackingService.trackEvent(trackingService.pages.usersManage.name, trackingService.pages.usersManage.actions.openSeriesAction);
        $location.path('/TMS/Series/' + courseId);
      }
    };

    $scope.changeSelectedUserTab = function (tabName) {
      $scope.selectedUserTabSelected = tabName;
    };

    $scope.selectedUserTabClass = function (tabName) {
      return $scope.selectedUserTabSelected == tabName ? 'active' : '';
    };

    setupSearch();

    if (searchData) {
      if (searchData.name == 'group') {
        filterByGroupId(searchData.id);
      } else if (searchData.name == 'email') {
        filterByEmail(searchData.id);
      } else if (searchData.name == 'username') {
        filterByUsername(searchData.id);
      }
    }
  }

})();
